import { render, staticRenderFns } from "./PatientsFormVisits.vue?vue&type=template&id=d0ef1b3a&"
import script from "./PatientsFormVisits.vue?vue&type=script&lang=js&"
export * from "./PatientsFormVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports